export enum ReportingFrequency {
  MONTHLY = "Monthly",
  QUARTERLY = "Quarterly",
  SEMI_ANNUAL = "Semi-Annual",
  ANNUAL = "Annual",
}

export enum UnderlyingType {
  COVERED = "Covered",
  UNCOVERED = "Uncovered",
}

export enum ManagementType {
  DIRECT = "Direct",
  SOLICITATION = "Solicitation",
  SUB_ADVISOR = "Sub-Advisor",
}

export enum OrderStatus {
  DRAFT = "draft",
  NEW = "new",
  STAGED = "staged",
  OPEN = "open",
  REJECTED = "rejected",
  CANCELED = "canceled",
  ERROR = "error",
  PARTIALLY_FILLED = "partially_filled",
  FILLED = "filled",
}

export enum FormMode {
  CREATE,
  EDIT,
}

export enum StrategyGroupEnum {
  STANDARD = 1,
  DIV_OPTIC = 2,
  GROWTH_OPTIC = 3,
  HEDGE = 4,
}

export enum StrategyGroupLabel {
  "Standard" = StrategyGroupEnum.STANDARD,
  "Div Optic" = StrategyGroupEnum.DIV_OPTIC,
  "Growth Optic" = StrategyGroupEnum.GROWTH_OPTIC,
  "Hedge" = StrategyGroupEnum.HEDGE,
}

export const DEFAULT_POLLING_INTERVAL = 60_000;

export enum LocalStorageKeys {
  LAST_STRATEGY_ID = "lastStrategyId",
  LAST_STRATEGY_GROUP_ID = "lastStrategyGroupId",
  LAST_STATISTIC_STRATEGY_ID = "lastStatisticStrategyId",
  LAST_STATISTIC_ACCOUNT_ID = "lastStatisticAccountId",
  LAST_STATISTIC_DATE_RANGE = "lastStatisticDateRange",
  LAST_STATISTIC_PERIODS = "lastStatisticPeriods",
  LAST_CLIENT_STOCK_ID = `lastPerformanceStockClientId`,
  LAST_ACCOUNT_STOCK_IDS = `lastPerformanceStockAccountIds`,
  LAST_PERIODS_STOCK = `lastPerformanceStockPeriods`,
  LAST_CLIENT_STRATEGY_ID = `lastPerformanceStrategyClientId`,
  LAST_ACCOUNT_STRATEGY_IDS = `lastPerformanceStrategyAccountIds`,
  LAST_PERIODS_STRATEGY = `lastPerformanceStrategyPeriods`,
}

export enum OrderType {
  MARKET = "market",
  LIMIT = "limit",
}

export const DEFAULT_LIMIT_PRICE = 0.0;

export const NOTISTACK_AUTO_HIDE_DURATION = 5_000;
export const NOTISTACK_MAX_SNACK = 3;

export const NOTISTACK_SUCCESS_OPTIONS = {
  variant: "success",
  anchorOrigin: { horizontal: "right", vertical: "bottom" },
};
export const NOTISTACK_FAILURE_OPTIONS = {
  variant: "error",
  anchorOrigin: { horizontal: "right", vertical: "bottom" },
};

export const NOTISTACK_ALERT_OPTIONS = {
  variant: "info",
  anchorOrigin: { horizontal: "right", vertical: "bottom" },
  persist: true,
};

export enum FDS_ActionTypes {
  GET = "GET",
  SUBSCRIBE = "SUBSCRIBE",
  UNSUBSCRIBE = "UNSUBSCRIBE",
}

export enum FDS_SubscriptionTypes {
  HOMEPAGE_STOCK = "HOMEPAGE_STOCK",
  HOMEPAGE_OPTION = "HOMEPAGE_OPTION",
  OPTION_CONTRACT = "OPTION_CONTRACT",
  OPTION_CHAIN = "OPTION_CHAIN",
  STOCK_PRICE = "STOCK_PRICE",
}

export const VolDaysOptions = [
  {
    label: "1 Year",
    value: 360,
  },
  {
    label: "3 Years",
    value: 1080,
  },
  {
    label: "5 Years",
    value: 1800,
  },
];

export enum ReportingMode {
  ACCOUNT_PREVIEW,
  ALL_ACCOUNTS,
}

export enum CompositeReportJobStatus {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  NOT_FOUND = "NOT_FOUND",
}

export const CALLS_HISTORY_PERIODS = [30, 60, 90, 180, 360];

export enum DateSelectionMode {
  YEAR = "year",
  MONTH = "month",
  RANGE = "range",
  INCEPTION = "inception",
}

export enum UrlPaths {
  REPORT_DEPRECATED = "/report-deprecated",
  REPORT = "/report",
}

export enum SingleValueCardType {
  CURRENCY = "currency",
  PERCENTAGE = "percentage",
  NUMBER = "number",
}

export enum SingleValueCardColor {
  PRIMARY = "primary",
  SECONDARY = "secondary",
  SUCCESS = "success",
  ERROR = "error",
  WARNING = "warning",
  INFO = "info",
}

export enum ReportQuarterTableColumn {
  Period = "Period",
  StockPrice = "Stock Price",
  OptionIncome = "Option Income",
  DividenIncome = "Dividen Income",
  TotalIncome = "Total Income",
  Comment = "Comment",
}

export interface QuarterRow {
  id: number;
  [ReportQuarterTableColumn.Period]: string;
  [ReportQuarterTableColumn.StockPrice]: number;
  [ReportQuarterTableColumn.OptionIncome]: number;
  [ReportQuarterTableColumn.DividenIncome]: number;
  [ReportQuarterTableColumn.TotalIncome]: number;
  [ReportQuarterTableColumn.Comment]: string;
}
